const CART_STORAGE_KEY = 'cheepsweepz_cart_v1';

export function readCart() {
  if (typeof window === 'undefined') return [];
  try {
    const raw = window.localStorage.getItem(CART_STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function writeCart(items) {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(items));
}

export function addToCart(product) {
  const id = product?.product_id || product?.id;
  if (!id) return readCart();
  const cart = readCart();
  const existing = cart.find((item) => item.product_id === id);
  if (existing) {
    existing.quantity = (existing.quantity || 1) + 1;
    writeCart(cart);
    return cart;
  }
  const next = [
    ...cart,
    {
      product_id: id,
      title: product.title || product.name,
      list_price: Number(product.list_price || product.price || 0),
      image_url: product.image_url || product.real_images?.[0] || '',
      marketplace: product.marketplace || '',
      quantity: 1,
    },
  ];
  writeCart(next);
  return next;
}

export function removeFromCart(productId) {
  const next = readCart().filter((item) => item.product_id !== productId);
  writeCart(next);
  return next;
}

export function cartTotal(items = readCart()) {
  return items.reduce((sum, item) => sum + Number(item.list_price || 0) * (item.quantity || 1), 0);
}
